import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconPair$1 = /*@__PURE__*/ proxyCustomElement(class WppIconPair extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-pair", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M15.335 17.2007H9.46495C9.24012 17.6733 8.75821 18 8.2 18C7.4268 18 6.8 17.3732 6.8 16.6C6.8 16.0396 7.12928 15.5561 7.60492 15.3324L7.6048 12.396L4.66684 12.3967C4.4583 12.8387 4.02527 13.1539 3.51482 13.1954L3.4 13.2C2.6268 13.2 2 12.5732 2 11.8C2 11.2415 2.32707 10.7593 2.80012 10.5347L2.80013 4.66495C2.32751 4.44012 2.00081 3.95821 2.00081 3.4C2.00081 2.6268 2.62761 2 3.40081 2C3.95902 2 4.44093 2.3267 4.66576 2.79932H10.535C10.7599 2.3267 11.2418 2 11.8 2C12.5732 2 13.2 2.6268 13.2 3.4C13.2 3.95978 12.8715 4.44283 12.3967 4.66684L12.396 7.6032L15.3332 7.60332C15.5417 7.16133 15.9747 6.84608 16.4852 6.80464L16.6 6.8C17.3732 6.8 18 7.4268 18 8.2C18 8.7579 17.6737 9.23958 17.2015 9.46457V15.3354C17.6737 15.5604 18 16.0421 18 16.6C18 17.3732 17.3732 18 16.6 18C16.0418 18 15.5599 17.6733 15.335 17.2007H9.46495H15.335ZM15.3366 8.80387L12.396 8.8032L12.3967 10.5311C12.8366 10.7403 13.1501 11.1723 13.1914 11.6812L13.196 11.796C13.196 12.5692 12.5692 13.196 11.796 13.196C11.2378 13.196 10.7559 12.8693 10.5311 12.3967L8.8048 12.396L8.80547 15.3373C9.09413 15.476 9.3279 15.7107 9.46533 16.0001H15.3347C15.4731 15.7086 15.7093 15.4726 16.0009 15.3343V9.46571C15.7521 9.34774 15.5436 9.15857 15.4018 8.92452L15.3366 8.80387ZM11.196 8.8032L9.46343 8.80387C9.32575 9.09141 9.0928 9.32463 8.80547 9.46266L8.8048 11.196L10.5307 11.1961C10.669 10.9049 10.9049 10.669 11.1961 10.5307L11.196 8.8032ZM10.5347 3.99988H4.66614C4.52783 4.29111 4.29193 4.52701 4.00068 4.66533V10.535C4.29021 10.6728 4.52498 10.907 4.66343 11.1961L7.6048 11.196L7.60492 9.4676C7.16209 9.25935 6.84613 8.82588 6.80464 8.31482L6.8 8.2C6.8 7.4268 7.4268 6.8 8.2 6.8C8.75978 6.8 9.24283 7.12854 9.46684 7.60332L11.196 7.6032L11.1961 4.66343C10.9481 4.54465 10.7404 4.35498 10.5995 4.12065L10.5347 3.99988Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-pair-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-pair", "wpp-icon-pair-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-pair-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-pair-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconPair$1);
      }
      break;
  } });
}

const WppIconPair = WppIconPair$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconPair, defineCustomElement };
